import _ from 'lodash'

export const state = () => ({
  templates: {
    stockTemplates: [
    ],
    userTemplates: [],
    currentTemplate: {meta:{thumbUrl:''}}
  },
  limits: {

  },
  currentEmailOptions: {
    emailSubject: '',
    headerIntro: false,
    headerIntroText: '',
    linkImage: false,
    addressCollectionButton: false,
    websiteButton: 'NONE',
    footer: false,
    designUri: '',
    sendTo: []
  },
  assets: {
    imageSystem: [],
    image: [],
    backgroundSystem: [],
    background: [],
    texts: [],
    shapes: []
  },
  eventData: {},
  theme: {
    themeFont: 'sackers_gl',
    themeFontsList: [],
    themeData: {},
    themeId: null
  },
  access: {
    is_admin: false
  },
  tour: {
    current: 'main'
  }
})

export const getters = {

}

export const mutations = {
  /**
   * tour
   */
  setLimits (state, data) {
    state.limits = data
  },
  /**
   * tour
   */
  setCurrentTour (state, data) {
    state.tour.current = data
  },
  /**
   * access
   */
  setAdminAccess (state, data) {
    state.access.is_admin = data
  },
  /**
   * TEMPLATES
   */
  setAllStockTemplates (state, data) {
    state.templates.stockTemplates = data
  },
  setAllUserTemplates (state, data) {
    state.templates.userTemplates = data
  },
  setCurrentTemplate (state, data) {
    state.templates.currentTemplate = data
  },
  /**
   * CANVAS / DESIGN
   */
  setDesignUri (state, data) {
    state.currentEmailOptions.designUri = data
  },
  /**
   * CONTACTS
   */
  setSendTo (state, data) {
    state.currentEmailOptions.sendTo = data
  },
  removeSendToItem (state, id) {
    let index = _.findIndex(state.currentEmailOptions.sendTo, { 'guest_id': id });
    if (index !== -1) {
      state.currentEmailOptions.sendTo.splice(index, 1);
    }
  },
  /**
   * EMAIL OPTIONS
   */
  setEmailSubject (state, data) {
    state.currentEmailOptions.emailSubject = data
  },
  setEmailOptionHeaderIntro (state, data) {
    state.currentEmailOptions.headerIntro = data
  },
  setEmailOptionHeaderIntroText (state, data) {
    state.currentEmailOptions.headerIntroText = data
  },
  setLinkToEventWebsite (state, data) {
    state.currentEmailOptions.linkToEventWebsite = data
  },
  setEmailOptionAddressCollectionButton (state, data) {
    state.currentEmailOptions.addressCollectionButton = data
  },
  setLinkImage (state,data) {
    state.currentEmailOptions.linkImage = data
  },
  setEmailOptionWebsiteButton (state, data) {
    state.currentEmailOptions.websiteButton = data
  },
  setEmailOptionFooter (state, data) {
    state.currentEmailOptions.footer = data
  },
  /**
   * ASSET MANAGEMENT
   */
  setAssetImage (state, image) {
    state.assets.image.push(image)
  },
  setAssetBackground (state, image) {
    state.assets.background.push(image)
  },
  setAllAssetImagesSystem (state, imagesArray) {
    state.assets.imageSystem = imagesArray
  },
  setAllAssetBackgroundsSystem (state, imagesArray) {
    state.assets.backgroundSystem = imagesArray
  },
  setAllAssetImages (state, imagesArray) {
    state.assets.image = imagesArray
  },
  setAllAssetBackgrounds (state, imagesArray) {
    state.assets.background = imagesArray
  },
  removeAssetImage (state, id) {
    let index = _.findIndex(state.assets.image, { 'id': id });
    if (index !== -1) {
      state.assets.image.splice(index, 1);
    }
  },
  removeAssetBackground (state, id) {
    let index = _.findIndex(state.assets.background, { 'id': id });
    if (index !== -1) {
      state.assets.background.splice(index, 1);
    }
  },
  setAllStockTexts (state, data) {
    state.assets.texts = data
  },
  setAllStockShapes (state, data) {
    state.assets.shapes = data
  },
  /**
   * EVENT
   */
  setEventData (state, data) {
    if (data !== null) {
      state.eventData = data
      state.eventId = data.id
    }
  },
  /**
   * THEME
   */
  setThemeData (state, data) {
    state.theme.themeData = data
    state.theme.themeId = data.theme_id
  },
  setThemeFont (state, data) {
    state.theme.themeFont = data
  },
  setThemeFontsList (state, data) {
    state.theme.themeFontsList = data
  },
}

export const actions = {

  /**
   * THEME
   */
  async fetchLimits ({ commit, state, rootState }, { $axios}) {
    try {
      const { data } = await $axios.post('/api/v1/openapi/email_get_tpl_limits', {})
      if (data.status === 200) {
        commit('setLimits', data.limits)
      }
    } catch (error) {
      console.log(error)
      if (error.response && error.response.status !== 200) {
        throw error;
      }
    }
  },

  /**
   * THEME
   */
  async fetchThemeFontsList ({ commit, state, rootState }, { $axios}) {
    try {
      const { data } = await $axios.post('/api/v1/feonly/get_site_fonts', {})
      if (data.status === 200) {
        commit('setThemeFontsList', data.items)
      }
    } catch (error) {
      console.log(error)
      if (error.response && error.response.status !== 200) {
        throw error;
      }
    }
  },

  async fetchThemeData ({ commit, state, rootState }, { $axios, themeId, mode }) {
    try {
      let params = {'theme_id': themeId}
      if (mode !== undefined) {
        params.mode = mode
      } else {
        params.mode = 'full'
      }
      if (themeId === undefined && rootState.emailEditor.eventData.theme_id !== null) {
        params.theme_id = rootState.emailEditor.eventData.theme_id
      }
      const { data } = await $axios.post('/api/v1/theme/get', params)
      if (data.status === 200) {
        commit('setThemeData', data)
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        // todo we should implement some course of action
        // throw new Error('Bad credentials')
      } else if (error.response && error.response.status === 400) {
        // todo we should implement some course of action
        // throw new Error('Bad credentials')
      } else {
        throw error
      }
    }
  },
  /**
   * EVENTS
   */
  async fetchEventData ({ commit }, { $axios, slug, eventId }) {
    try {
      let params = {}
      if (slug !== undefined) {
        params.mode = 'url'
        params.name = slug
      } else {
        params.event_id = eventId
      }
      const { data } = await $axios.post('/api/v1/event/get_info', params)
      if (data.status === 200) {
        let paramsProfile = {uid: data.event.owner_uid, event_id: data.event.id }
        const {data: dataUser} = await $axios.post('/api/v1/openapi/event_get_owner_info', paramsProfile);
        if (dataUser.status === 200 && dataUser?.owner?.email !== undefined) {
          data.event.owner_user = dataUser.owner;
        }
        commit('setEventData', data.event) // local mutation
        commit('setThemeFont', data.event.theme_font_package) // local mutation
      }
    } catch (error) {
      console.log('ooops error', error);
      if (error.response && error.response.status === 403) {
        // todo we should implement some course of action
        // throw new Error('Bad credentials')
      } else if (error.response && error.response.status === 400) {
        // todo we should implement some course of action
        // throw new Error('Bad credentials')
      } else {
        throw error
      }
    }
  },
  /**
   * EMAIL DESIGN TEMPLATES
   *
   */
  async fetchTemplatesList ({ commit, state, rootState }, { $axios, eventId, mode, useMaster, type }) {
    try {
      let params = {'event_id': eventId}
      if (mode !== undefined && mode !== null) {
        params.mode = mode
      } else {
        params.mode = 'all'
      }
      if (type !== undefined && type !== null) {
        params.type = type.toUpperCase();
      } else {
        params.type = 'TPL'
      }
      if (useMaster !== undefined && useMaster !== null) {
        params.use_master = useMaster
      } else {
        params.use_master = false
      }
      const { data } = await $axios.post('/api/v1/email/get_templates', params)
      if (data.status === 200) {
        if (data?.is_admin !== undefined) {
          commit('setAdminAccess', data.is_admin)
        }
        // FOR GENERAL TEMPLATES
        if (params.type === 'TPL') {
          if (data?.items?.system !== undefined && Array.isArray(data.items.system) && ['all','system_only'].includes(params.mode) ) {
            for ( let idx = 0; idx < data.items.system.length; idx++) {
              if (typeof data.items.system[idx] !== 'undefined' && typeof data.items.system[idx].data === 'string') {
                try {
                  data.items.system[idx].data = JSON.parse(data.items.system[idx].data)
                } catch (err) {

                }
              }
              if (typeof data.items.system[idx] !== 'undefined' && typeof data.items.system[idx].meta === 'string') {
                try {
                  data.items.system[idx].meta = JSON.parse(data.items.system[idx].meta)
                } catch (err) {

                }
              }
              data.items.system[idx]['mode']  = 'system'
            }
            commit('setAllStockTemplates', data.items.system)
          }
          if (data?.items?.user !== undefined && Array.isArray(data.items.user) && ['all','user_only'].includes(params.mode)) {
            for ( let idx = 0; idx < data.items.user.length; idx++) {
              if (typeof data.items.user[idx] !== 'undefined' && typeof data.items.user[idx].data === 'string') {
                try {
                  data.items.user[idx].data = JSON.parse(data.items.user[idx].data)
                } catch (err) {

                }
              }
              if (typeof data.items.user[idx] !== 'undefined' && typeof data.items.user[idx].meta === 'string') {
                try {
                  data.items.user[idx].meta = JSON.parse(data.items.user[idx].meta)
                } catch (err) {

                }
              }
              data.items.user[idx]['mode'] = 'user'
            }
            commit('setAllUserTemplates', data.items.user)
          }
        }
        else if (params.type === 'TEXT') {
          if (data?.items?.system !== undefined && Array.isArray(data.items.system) && ['all','system_only'].includes(params.mode) ) {
            for ( let idx = 0; idx < data.items.system.length; idx++) {
              if (typeof data.items.system[idx] !== 'undefined' && typeof data.items.system[idx].data === 'string') {
                try {
                  data.items.system[idx].data = JSON.parse(data.items.system[idx].data)
                } catch (err) {

                }
              }
              if (typeof data.items.system[idx] !== 'undefined' && typeof data.items.system[idx].meta === 'string') {
                try {
                  data.items.system[idx].meta = JSON.parse(data.items.system[idx].meta)
                } catch (err) {

                }
              }
              data.items.system[idx]['mode']  = 'system'
            }
            commit('setAllStockTexts', data.items.system)
          }
        }
        else if (params.type === 'SHAPE') {
          if (data?.items?.system !== undefined && Array.isArray(data.items.system) && ['all','system_only'].includes(params.mode) ) {
            for ( let idx = 0; idx < data.items.system.length; idx++) {
              if (typeof data.items.system[idx] !== 'undefined' && typeof data.items.system[idx].data === 'string') {
                try {
                  data.items.system[idx].data = JSON.parse(data.items.system[idx].data)
                } catch (err) {

                }
              }
              if (typeof data.items.system[idx] !== 'undefined' && typeof data.items.system[idx].meta === 'string') {
                try {
                  data.items.system[idx].meta = JSON.parse(data.items.system[idx].meta)
                } catch (err) {

                }
              }
              data.items.system[idx]['mode']  = 'system'
            }
            commit('setAllStockShapes', data.items.system)
          }
        }
      }
    } catch (error) {
      console.log(error)
      if (error.response && error.response.status !== 200) {
        throw error;
      }
    }
  },
  async saveTemplate ({ dispatch, rootState, commit, state }, { $axios, requestData }) {
    try {
      const { data } = await $axios.post('/api/v1/email/modify_template', requestData)
      if (data.status === 200) {
        // we could have saved user or system/stock templates so we need to know which list we are updating
        let fetchMode = 'user_only';
        if (requestData?.mode !== undefined && requestData.mode.toUpperCase() === 'SYSTEM') {
          fetchMode = 'system_only';
        }
        let fetchType = 'TPL';
        if (requestData?.type !== undefined && requestData.type !== null) {
          fetchType = requestData.type.toUpperCase()
        }
        // refresh the updated list
        await dispatch('fetchTemplatesList', {$axios: $axios, 'eventId': rootState.user.session.selected_event, 'mode': fetchMode, 'useMaster': true, type: fetchType})

        let templateId = null;
        // we only use this for newly added items
        if (data.email_tpl_id !== undefined && data.email_tpl_id !== null) {
          templateId = data.email_tpl_id;
        }
        // we only use this for updates - so we can repopulate current template - if delete we do not want to run it
        else if ( (requestData.delete === undefined || requestData.delete === 0) && requestData.email_tpl_id !== undefined && requestData.email_tpl_id !== null ) {
          templateId = requestData.email_tpl_id;
        }

        if (fetchType === 'TPL') {
          // we only set current if templateid was available
          if (templateId !== null) {
            let foundTemplate;
            if (fetchMode === 'user_only') {
              foundTemplate = _.find(state.templates.userTemplates, { 'id': templateId });
            }
            else {
              foundTemplate = _.find(state.templates.stockTemplates, { 'id': templateId });
            }
            // console.log('foundTemplate', foundTemplate, 'operatingList', state.templates.stockTemplates, 'id', templateId);
            if (typeof foundTemplate === 'object') {
              // set current template used when new one is added
              commit('setCurrentTemplate', foundTemplate)
            }
          } else {
            // we are setting it empty
            commit('setCurrentTemplate', {meta:{thumbUrl:null}})
          }
        }
      }
    } catch (error) {
      if (error.response && error.response.status !== 200) {
        throw error;
      }
    }
  },

  /**
   * ASSETS ( IMAGE / BACKGROUND )
   */
  async fetchAssetList ({ commit, state, rootState }, { $axios, eventId, mode, useMaster, type }) {
    try {
      let params = {'event_id': eventId}
      if (mode !== undefined && mode !== null) {
        params.mode = mode.toUpperCase();
      } else {
        params.mode = 'ALL'
      }
      if (type !== undefined && type !== null) {
        params.type = type.toUpperCase();
      } else {
        params.type = 'ALL'
      }

      if (useMaster !== undefined && useMaster !== null) {
        params.use_master = useMaster
      } else {
        params.use_master = false
      }
      const { data } = await $axios.post('/api/v1/email/get_images', params)

      if (data.status === 200) {
        let systemImages = [],
          systemBackgrounds = [],
          userImages = [],
          userBackgrounds = [];

        // process system assets
        if (data?.items?.system !== undefined && (params.mode === 'SYSTEM_ONLY' || params.mode === 'ALL') ) {
          for (let idx = 0; idx < data.items.system.length; idx++) {
            if (typeof data.items.system[idx] !== 'undefined' && typeof data.items.system[idx].url === 'string') {
              data.items.system[idx]['mode'] = 'system';
              if (data.items.system[idx].type.toUpperCase() === 'IMAGE') {
                systemImages.push(data.items.system[idx])
              }
              else if (data.items.system[idx].type.toUpperCase() === 'BG') {
                systemBackgrounds.push(data.items.system[idx])
              }
            }
          }
          if (params.type === 'ALL' || params.type === 'IMAGE') {
            commit('setAllAssetImagesSystem', systemImages);
          }
          if (params.type === 'ALL' || params.type === 'BG') {
            commit('setAllAssetBackgroundsSystem', systemBackgrounds);
          }
        }
        // process user assets
        if (data?.items?.user !== undefined && (params.mode === 'USER_ONLY' || params.mode === 'ALL')) {
          for (let idx = 0; idx < data.items.user.length; idx++) {
            if (typeof data.items.user[idx] !== 'undefined' && typeof data.items.user[idx].url === 'string') {
              data.items.user[idx]['mode'] = 'user';
              if (data.items.user[idx].type.toUpperCase() === 'IMAGE') {
                userImages.push(data.items.user[idx])
              }
              else if (data.items.user[idx].type.toUpperCase() === 'BG') {
                userBackgrounds.push(data.items.user[idx])
              }
            }
          }
          if (params.type === 'ALL' || params.type === 'IMAGE') {
            commit('setAllAssetImages', userImages);
          }
          if (params.type === 'ALL' || params.type === 'BG') {
            commit('setAllAssetBackgrounds', userBackgrounds);
          }
        }
      }
    } catch (error) {
      console.log(error)
      if (error.response && error.response.status !== 200) {
        throw error;
      }
    }
  },
  // only user assets can be saved from UI interface right now
  async saveAsset ({ dispatch, rootState, commit, state }, { $axios, requestData }) {
    try {
      if (requestData?.event_id === undefined) {
        requestData.event_id = rootState.user.session.selected_event;
      }
      const { data } = await $axios.post('/api/v1/email/modify_image', requestData)
      if (data.status === 200) {

        let fetchMode = 'USER_ONLY';
        let fetchType = 'ALL';
        if (requestData?.type !== undefined && requestData.type !== null) {
          fetchType = requestData.type.toUpperCase()
        }
        // refresh the updated list
        await dispatch('fetchAssetList', {$axios: $axios, 'eventId': rootState.user.session.selected_event, 'mode': fetchMode, 'useMaster': true, type: fetchType})
      }
    } catch (error) {
      if (error.response && error.response.status !== 200) {
        throw error;
      }
    }
  },
  /**
   * TEMPLATE GUESTS
   */
  async fetchSelectedGuests ({ commit, state, rootState }, { $axios, eventId, emailTemplateId, useMaster }) {
    try {
      let params = {'event_id': eventId, 'email_tpl_id': emailTemplateId}
      if (useMaster !== undefined && useMaster !== null) {
        params.use_master = useMaster
      } else {
        params.use_master = false
      }
      const { data } = await $axios.post('/api/v1/email/get_template_guests', params)

      if (data.status === 200) {

        let matchedGuests = _.filter(rootState.guest.guests, (item) => {
          // NOTE:  workaround data-table missing capabilities so we filter out those records with no email
          return data.items.includes(item.guest_id)
        });
        commit('setSendTo', matchedGuests);

      }
    } catch (error) {
      console.log(error)
      if (error.response && error.response.status !== 200) {
        throw error;
      }
    }
  },
  async saveSelectedGuests ({ dispatch, rootState, commit, state }, { $axios, requestData }) {
    try {
      if (requestData?.event_id === undefined) {
        requestData.event_id = rootState.user.session.selected_event;
      }
      const { data } = await $axios.post('/api/v1/email/modify_template_guests', requestData)
      if (data.status === 200) {

        // TO DO - we might refresh the list as needed
        // refresh the updated list
        // await dispatch('fetchAssetList', {$axios: $axios, 'eventId': rootState.user.session.selected_event, 'useMaster': true})
      }
    } catch (error) {
      if (error.response && error.response.status !== 200) {
        throw error;
      }
    }
  },

}
